module.exports = __webpack_public_path__ + "static/img/zaixianherong.0b0843f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zaixianherong.png
// module id = TcUc
// module chunks = 1